<app-accordion
  [nomeComponente]="'endereco'"
  [tituloAccordion]="'Dados de Endereço'"
  [iconeAccordion]="'fa fa-map-marker'"
  [estaAberto]="estaAberto"
  [camposInvalidos]="enderecoForm.invalid && showErrorMessage">
  <!-- Formulário -->
  <form
    class="form row"
    [formGroup]="enderecoForm"
    *ngIf="mostrarFormulario"
    (ngSubmit)="$event.preventDefault(); buscarCEP()">
    <ng-container *ngIf="mostrarCampoSelectEstadoCidade; else campoDescritivoEstadoCidade">
      <!-- Estado -->
      <div class="form-group col-sm-12 col-md-4">
        <label for="stateId">Estado</label>
        <ng-select
          [multiple]="false"
          [loading]="false"
          [closeOnSelect]="true"
          [searchable]="true"
          notFoundText="Nenhum registro localizado"
          [ngClass]="{
            'campo-obrigatorio': enderecoForm.controls['stateId'].errors && isFormSubmited
          }"
          (change)="changeEstado($event)"
          class="round shadow"
          formControlName="stateId">
          <ng-option *ngFor="let estado of listaEstados" value="{{ estado.id }}">
            {{ estado.name }}
          </ng-option>
        </ng-select>
        <app-validacao-form-input
          [nomeFormulario]="enderecoForm"
          nomeCampo="stateId"
          [maxLength]="250"
          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
      </div>
      <!-- Cidade -->
      <div class="form-group col-sm-12 col-md-5">
        <label for="cityId">Cidade</label>
        <ng-select
          [multiple]="false"
          [loading]="false"
          [closeOnSelect]="true"
          [searchable]="true"
          notFoundText="Nenhum registro localizado"
          (change)="limparCamposEndereco()"
          [ngClass]="{
            'campo-obrigatorio': enderecoForm.controls['cityId'].errors && isFormSubmited
          }"
          class="round shadow"
          formControlName="cityId">
          <ng-option *ngFor="let cidade of listaCidades" value="{{ cidade.id }}">
            {{ cidade.name }}
          </ng-option>
        </ng-select>
        <app-validacao-form-input
          [nomeFormulario]="enderecoForm"
          nomeCampo="cityId"
          [maxLength]="250"
          [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
      </div>
    </ng-container>
    <!-- CEP -->
    <div class="form-group mb-1 col-sm-12 col-md-3">
      <label for="adressCep">CEP</label>
      <input
        type="text"
        mask="00000-000"
        [showMaskTyped]="true"
        class="form-control round"
        autocomplete="off"
        id="adressCep"
        formControlName="adressCep"
        required
        (ngModelChange)="onFieldChange()"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['adressCep'].errors && isFormSubmited
        }" />
      <app-validacao-form-input
        [nomeFormulario]="enderecoForm"
        nomeCampo="adressCep"
        [maxLength]="250"
        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
    </div>
    <!-- Endereço Completo -->
    <div class="form-group mb-1 col-sm-12 col-md-6">
      <label for="adress">Endereço Completo</label>
      <input
        type="text"
        class="form-control round"
        id="adress"
        formControlName="adress"
        maxlength="250"
        required
        (ngModelChange)="onFieldChange()"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['adress'].errors && isFormSubmited
        }" />
      <app-validacao-form-input
        [nomeFormulario]="enderecoForm"
        nomeCampo="adress"
        [maxLength]="250"
        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
    </div>
    <!-- Bairro -->
    <div class="form-group mb-1 col-sm-12 col-md-3">
      <label for="adressNeighborhood">Bairro</label>
      <input
        type="text"
        maxlength="150"
        class="form-control round"
        id="adressNeighborhood"
        formControlName="adressNeighborhood"
        required
        (ngModelChange)="onFieldChange()"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['adressNeighborhood'].errors && isFormSubmited
        }" />
      <app-validacao-form-input
        [nomeFormulario]="enderecoForm"
        nomeCampo="adressNeighborhood"
        [maxLength]="250"
        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
    </div>
    <!-- Número -->
    <div class="form-group mb-1 col-sm-12 col-md-3 mb-1" *ngIf="!ocultarNumero">
      <label for="adressNumber">Número</label>
      <input
        type="text"
        maxlength="10"
        class="form-control round"
        id="adressNumber"
        formControlName="adressNumber"
        [required]="numeroObrigatorio"
        (ngModelChange)="onFieldChange()"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['adressNumber'].errors && isFormSubmited
        }"
        pattern="[a-zA-Z0-9]*" />
      <app-validacao-form-input
        [nomeFormulario]="enderecoForm"
        nomeCampo="adressNumber"
        [maxLength]="250"
        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
    </div>
    <!-- Complemento -->
    <div class="form-group mb-1 col-sm-12 col-md-3 mb-1" *ngIf="!ocultarComplemento">
      <label for="adressComplement">Complemento</label>
      <input
        type="text"
        maxlength="250"
        class="form-control round"
        id="adressComplement"
        formControlName="adressComplement" />
    </div>
    <!-- Tipo de Endereço  -->
    <div class="form-group col-sm-12 col-md-3 mb-3" *ngIf="mostrarTipoEndereco">
      <label for="adressType">Tipo de Endereço</label>
      <ng-select
        [multiple]="false"
        [loading]="false"
        [closeOnSelect]="true"
        [searchable]="true"
        notFoundText="Nenhum registro localizado"
        [ngClass]="{
          'campo-obrigatorio': enderecoForm.controls['adressType'].errors && isFormSubmited
        }"
        class="round shadow"
        formControlName="adressType">
        <ng-option [value]="1">Residencial</ng-option>
        <ng-option [value]="2">Comercial</ng-option>
        <ng-option [value]="3">Cobrança</ng-option>
      </ng-select>
      <app-validacao-form-input
        [nomeFormulario]="formularioInscricaoEntidade"
        nomeCampo="adressType"
        [maxLength]="250"
        [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
    </div>
    <ng-template #campoDescritivoEstadoCidade>
      <!-- Estado Descritivo -->
      <div class="form-group col-md-4 mb-1">
        <label for="stateName">Estado</label>
        <input
          type="text"
          readonly
          maxlength="250"
          class="form-control round"
          id="stateName"
          formControlName="stateName" />
      </div>
      <!-- Cidade Descritivo-->
      <div class="form-group col-md-5 mb-1">
        <label for="cityName ">Cidade</label>
        <input
          type="text"
          readonly
          maxlength="250"
          class="form-control round"
          id="cityName"
          formControlName="cityName" />
      </div>
    </ng-template>
    <!-- Moradia Internacioanl -->
    <!-- <div *ngIf="isMoradiaInternacional" class="form-group col-sm-6 col-md-4 mb-1">
      <label for="internationalCity">Cidade</label>
      <input
        type="text"
        class="round form-control"
        id="OtherCityInternational"
        maxlength="250"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['internationalCity'].errors && isFormSubmited
        }"
        formControlName="internationalCity" />
    </div>
    <div *ngIf="isMoradiaInternacional" class="form-group col-sm-6 col-md-5 mb-1">
      <label for="internationalState">Estado</label>
      <input
        type="text"
        class="round form-control"
        id="otherStateInternational"
        maxlength="250"
        [ngClass]="{
          'is-invalid': enderecoForm.controls['internationalState'].errors && isFormSubmited
        }"
        formControlName="internationalState" />
    </div>
    <div class="form-group col-sm-12 col-md-4">
      <label for="Moradia Internacional">Moradia Internacional?</label>
      <br />
      <label>
        <input
          (change)="onChangeMoradiaInternacional($event)"
          value="NÃO"
          [value]="false"
          id="Inactive"
          type="radio"
          class="input-radio on"
          name="internationalHome"
          checked
          formControlName="internationalHome"
          (ngModelChange)="onFieldChange()" />
        NÃO
      </label>
      <label>
        <input
          (change)="onChangeMoradiaInternacional($event)"
          value="SIM"
          [value]="true"
          id="active"
          type="radio"
          class="input-radio off"
          name="internationalHome"
          formControlName="internationalHome"
          (ngModelChange)="onFieldChange()" />
        SIM
      </label>
    </div> -->
  </form>
  <!-- Botões -->
  <div class="float-right" *ngIf="!ocultarBtnAcao && mostrarFormulario">
    <button
      *ngIf="mostrarBtnAdicionar && !ehSomenteLeitura"
      (click)="addEndereco()"
      class="btn btn-success btn-round btn-format float-right mr-2 mb-1 btn-min-width"
      type="button">
      <i class="ft-plus"></i>
      {{ editingIndex > -1 ? 'Atualizar' : 'Adicionar' }}
    </button>

    <button
      (click)="reset(); editingIndex = -1"
      class="btn btn-warning btn-round btn-format float-right mr-2 mb-1 btn-min-width"
      type="button">
      <i class="ft-trash"></i>
      Limpar
    </button>
  </div>
  <!-- Tabela -->
  <app-tabela
    *ngIf="!ocultarTabela"
    [listaTabela]="enderecoList"
    [colunasTabela]="colunasTabela"
    [mostrarColunaAcao]="mostrarColunaAcao"
    [podeCadastrarEditar]="podeCadastrarEditar"
    [somenteLeitura]="ehSomenteLeitura"
    [config]="config"
    (emitirAcaoBotao)="ehAcaoBtnTabela($event)"></app-tabela>
</app-accordion>
